// The price book's views' props, as zod (pages/ux-full screens/setup.js, the item's History):
// pricebook.itemHistory's answer as it is. Not in TOOL_VIEWS yet.
//
// The price book's views' props, as zod (pages/ux-full components/setup.js PriceBookRow's picture, and
// the item's pictures in its sheet): pricebook.listItems' `picture` and pricebook.getItem's `media`, as
// the tools give them. Not in TOOL_VIEWS yet.
import { z } from 'zod';

const Id = z.string().min(1);
const Value = z.union([z.string(), z.number(), z.boolean()]).nullable();

/** One field's change on an item: its old and new value, how, why and who. */
export const ItemChange = z.object({
  id: Id,
  at: z.string(),
  /** The item's column: price_cents, name, category_id, … */
  field: z.string(),
  old: Value,
  new: Value,
  /** A category change: the categories' names (null: none, or one since removed). */
  category: z.object({ old: z.string().nullable(), new: z.string().nullable() }).optional(),
  source: z.enum(['manual', 'import', 'servicetitan', 'supplier_list', 'draft', 'rollback']),
  reason: z.string().nullable(),
  /** The fields one save, import or refresh changed together share it. */
  batchId: Id.nullable(),
  rollbackOf: Id.nullable(),
  by: z.object({ ref: z.string(), name: z.string().nullable() }),
});
export type ItemChange = z.infer<typeof ItemChange>;

/** pricebook.itemHistory: an item's changes, newest first, a page at a time. */
export const ItemHistoryProps = z.object({ changes: z.array(ItemChange), next: Id.nullable() });
export type ItemHistoryProps = z.infer<typeof ItemHistoryProps>;

/** A row's picture (pricebook.listItems): the primary picture's thumbnail, or null when it has none. */
export const ItemPictureProps = z.object({
  /** The item's name, for the picture's words. */
  name: z.string(),
  picture: z
    .object({
      fileId: Id,
      thumbUrl: z.string().nullable(),
      /** came over from the company's previous system, not added here by a person */
      imported: z.boolean().optional(),
    })
    .nullable(),
});
export type ItemPictureProps = z.infer<typeof ItemPictureProps>;

/** One of an item's pictures or spec sheets (pricebook.getItem's media), in its order. */
export const ItemMediaEntry = z.object({
  fileId: Id,
  kind: z.enum(['photo', 'document']),
  contentType: z.string(),
  isPrimary: z.boolean(),
  caption: z.string().nullable(),
  url: z.string().nullable(),
  thumbUrl: z.string().nullable(),
  /** came over from the company's previous system, not added here by a person */
  imported: z.boolean().optional(),
});
export type ItemMediaEntry = z.infer<typeof ItemMediaEntry>;

/** An item's pictures and spec sheets: pricebook.getItem's answer (its name and media). */
export const ItemMediaProps = z.object({ name: z.string(), media: z.array(ItemMediaEntry) });
export type ItemMediaProps = z.infer<typeof ItemMediaProps>;
